/*
 * utiliza os métodos da date.js (ehPresenteOuPassado, ehFuturo)
 * como os mixins sao injetados na raiz do projeto
 * nao ha necessidade de import
 */
export default {
    methods: {
        ehEtapaDeLances(dataHoraInicioLances, situacaoCompraDireta, amparoLegal) {
            if (situacaoCompraDireta !== 'ABERTA') return false

            if (this.exibirFimPropostasELances(amparoLegal) === true)
                return this.ehPresenteOuPassado(dataHoraInicioLances)

            return true
        },
        ehEtapaDePropostas(dataHoraFimEnvioProposta, situacaoCompraDireta, amparoLegal) {
            if (situacaoCompraDireta !== 'ABERTA') return false

            // a comparacao explicita e necessaria para casos de undefined
            if (this.exibirFimPropostasELances(amparoLegal) === true)
                return this.ehFuturo(dataHoraFimEnvioProposta)

            return true
        }
    }
}